import { Component, h, Method } from '@stencil/core';
import { getArray, isRtl, getRandom } from '@ugc-utils/utils';
import state, { store } from '@ugc-store';
import { Close, CheckC, Warning, FilledError } from '../../icons/index';
import { ToastType } from './interfaces';

@Component({
  tag: 'ugc-alert',
  styleUrl: 'ugc-alert.scss',
  shadow: false,
})
export class UgcAlert {
  componentWillLoad() {
    store.onChange('toastInfo', data => {
      if (data && data.length) {
        data.forEach(item => {
          if (!item.timer && item.timer !== null) {
            item.timer = window.setTimeout(() => {
              state.toastInfo = state.toastInfo.filter(toast => toast.id !== item.id);
              item.timer = null;
              clearTimeout(item.timer);
            }, 5000);
          }
        });
      }
    });
  }

  handleCloseToast(id) {
    if (id) {
      state.toastInfo = state.toastInfo.filter(toast => toast.id !== id);
    }
  }

  renderToastMessage(message) {
    const contentStyle = { flex: '1', margin: isRtl() ? '0 16px 0 29px' : '0 29px 0 16px' };

    return (
      <div class="flex-col-center-start" style={contentStyle}>
        {getArray(message).map(item => (
          <span class="fs-14 alert-message fw-500">{item}</span>
        ))}
      </div>
    );
  }

  renderIcon(type) {
    switch (type) {
      case ToastType.success:
        return <CheckC width="24" height="24" fill="#fff" />;
      case ToastType.warn:
        return <Warning width="24" height="24" fill="#333" />;
      case ToastType.error:
        return <FilledError width="24" height="24" fill="#fff" />;
    }
  }

  renderClose(id, type) {
    return (
      <div onClick={this.handleCloseToast.bind(this, id)}>
        <Close width="16" height="16" fill={type === ToastType.warn ? '#333' : '#fff'} />
      </div>
    );
  }

  @Method()
  async showToast(info) {
    const hasToast = state.toastInfo.find(toast => toast.message.join(',') === info.message.join(','));
    if (!hasToast) {
      const randomId = getRandom();
      info.id = randomId;
      state.toastInfo = [...state.toastInfo, info];
    }
    return Promise.resolve();
  }

  render() {
    const { toastInfo = [] } = state;
    return (
      <div class="alert-wrap">
        {toastInfo.map(item => {
          return (
            <div
              class={`alert-content flex-row-start-center alert-content-${ToastType[item.type]} ${
                isRtl() ? 'alert-left-enter' : 'alert-right-enter'
              }`}
            >
              {this.renderIcon(item.type)}
              {this.renderToastMessage(item.message)}
              {this.renderClose(item.id, item.type)}
            </div>
          );
        })}
      </div>
    );
  }
}
